import { render, staticRenderFns } from "./StitchingView.vue?vue&type=template&id=ca822454&scoped=true"
import script from "./StitchingView.vue?vue&type=script&lang=js"
export * from "./StitchingView.vue?vue&type=script&lang=js"
import style0 from "./StitchingView.vue?vue&type=style&index=0&id=ca822454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca822454",
  null
  
)

export default component.exports